import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';

import { Notify, NotifyService } from '../../shared/notify.service';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent {
  /**
   * サイドバーが開いている状態であるか
   */
  @Input() set expanded(value: boolean) {
    this._expanded = value;
  }

  get expanded(): boolean {
    return this._expanded;
  }

  public _expanded = false;

  /**
   * コンテンツの幅
   */
  @Input() contentWidth = 1;

  /**
   * コンテンツの幅
   */
  @Input() title = '';

  /**
   * 通知オブジェクト
   */
  public notify: Notify;

  /**
   * サイドバーのクローズを伝える
   */
  @Output() close: EventEmitter<boolean> = new EventEmitter();

  @ViewChild('dialogBox') dialogBox!: ElementRef;

  /**
   * コンストラクタ
   * @param notifyService
   */
  constructor(private notifyService: NotifyService) {
    this.notify = this.notifyService.getNotify();
  }

  ngOnChanges(changes: SimpleChanges): void {
    const currentContentWidth = changes['contentWidth']?.currentValue;
  }

  /**
   * パネル外のクリックでパネルをクローズする
   * @param event
   */
  @HostListener('document:mousedown', ['$event'])
  onClickOut(event: MouseEvent): void {
    if (!this.dialogBox.nativeElement.contains(event.target)) {
      this._close();
    }
  }

  /**
   * (HostListner) マウスホイールで親要素に対する伝搬を止める
   * @param $event any
   */
  @HostListener('mousewheel', ['$event'])
  onMousewheel($event: any): void {
    if (this._expanded === true) {
      $event.stopPropagation();
    }
  }

  /**
   * (HostListner) タッチムーブで親要素に対する伝搬を止める
   * @param $event any
   */
  @HostListener('touchmove', ['$event'])
  onTouchmove($event: any): void {
    if (this._expanded === true) {
      $event.stopPropagation();
    }
  }

  /**
   * パネルをクローズする
   */
  public _close(): void {
    this._expanded = false;
    this.close.emit(false);
  }

  public isOpen(): string {
    return this._expanded ? 'open' : 'close';
  }
}
